export * as premiumProductCatalog from '@wix/auto_sdk_premium-product-type_premium-product-catalog/meta';
